<template>
  <div class="approval">
    <!--  合同审批(新增、编辑) -->
    <!-- apply approval (create, update) and sign approval (create, update) -->
    <div class="content">
      <el-form
        size="mini"
        ref="formApproval"
        @submit.native.prevent
        :model="approvalModel"
        label-width="100px"
      >
        <el-form-item label="审批名称" prop="approvalName" :rules="rules.approvalName">
          <el-input style="width: 300px" v-model="approvalModel.approvalName" placeholder="请输入审批名称"></el-input>
        </el-form-item>
        <el-form-item label="审批类型" prop="approvalType" :rules="rules.approvalType">
          <el-radio-group v-model="approvalModel.approvalType">
            <el-radio :label="1">顺序审批（按先后顺序审批）</el-radio>
            <el-radio :label="2">会审 （无顺序，全员通过则通过）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批流程" required>
          <div style="display: inline; position: relative">
            <div class="flow-sty">
              <div v-for="user of flows" :key="user.emplId">
                <div class="men-item">
                  <img src="/images/web/p-default.png" width="50px" height="50px" alt />
                  <span :title="user.name" class="name-warp">
                    {{
                    user.name
                    }}
                  </span>
                  <span class="item-close close_icon" @click="delUser(user)"></span>
                </div>
                <i
                  class="icon icon-audit-jiantou32"
                  style="width: 30px"
                  v-show="approvalModel.approvalType === 1"
                ></i>
              </div>
              <el-popover placement="right">
                <div style="padding: 20px">
                  <p style="margin-bottom: 20px">
                    <el-button size="mini" style="width: 125px" @click="addManager">添加直属部门主管</el-button>
                  </p>
                  <p>
                    <el-button size="mini" style="width: 125px" @click="handleClickFlowPlus">选择成员</el-button>
                  </p>
                </div>
                <!-- <plus slot="reference" @handleClickFlowPlus="handleClickFlowPlus"></plus> -->
                <plus slot="reference"></plus>
              </el-popover>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="抄送人" prop="copyToName" :rules="rules.copyToName">
          <div style="display: inline; position: relative">
            <flow
              v-for="(v, index) in copyToMembers"
              @handleClickFlowRemove="handleClickCopyRemove"
              :model="v"
              :hiddenArrow="false"
              :key="index"
            >
              <div slot="username">
                <span style="color: #aaaaaa">{{ v.partyName }}</span>
              </div>
              <div slot="update">
                <a class="custom-a" @click="handleClickCopyUpdate(v)" href="javascript:void(0);">修改</a>
              </div>
            </flow>
            <plus @handleClickFlowPlus="handleClickCopyPlus"></plus>
          </div>
        </el-form-item>
        <el-form-item label="已授权成员" prop="dingTalkUserIds">
          <ul class="custom-inline">
            <template>
              <li class="both">
                <!-- <el-button @click="initMemberForm">选择</el-button> -->
                <plus @handleClickFlowPlus="initMemberForm"></plus>
              </li>
              <li
                class="men-item"
                style="width:60px;"
                v-if="!(approvalModel.dingTalkUserIds.length) && !isEdit"
              >
                <img src="/images/web/p-default.png" width="50px" height="50px" alt />
                <span title="全体成员" class="name-warp">全体成员</span>
              </li>
            </template>
            <li style="margin-top: 20px">
              <el-tag
                v-for="tag in approvalModel.dingTalkUserIds"
                :key="tag.name"
                type="danger"
                closable
                @close="tagRemove(tag)"
                style="margin: 0 10px; margin-bottom: 10px"
              >{{ tag.name }}</el-tag>
            </li>
          </ul>
        </el-form-item>
      </el-form>
      <el-dialog title="选择抄送人" :visible.sync="visibleDialogSelectCopy" width="800px">
        <el-row :gutter="20">
          <el-col :span="24">
            <!-- table -->
            <section>
              <el-form
                style="margin-top: 20px; text-align: right"
                :inline="true"
                size="small"
                :model="filterModel"
              >
                <el-form-item label>
                  <el-input
                    style="width: 150px"
                    v-model="filterModel.targetId"
                    placeholder="邮箱/手机号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                    style="width: 150px"
                    v-model="filterModel.corpUserName"
                    placeholder="签署方名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-select
                    v-model="filterModel.corpGroupId"
                    placeholder="请选择部门"
                    style="width: 150px"
                  >
                    <el-option label="全部" value></el-option>
                    <el-option
                      v-for="(item, i) in memberGroups"
                      :key="i"
                      :label="item.groupName"
                      :value="item.corpGroupId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-right: 0px">
                  <el-button @click="handleClickSearchManager">查询</el-button>
                  <el-button @click="approvalReset">重置</el-button>
                </el-form-item>
              </el-form>
              <!-- table -->
              <el-col :span="24" class="custom-table-style" style="padding: 0px">
                <el-table
                  :data="tableSetManager"
                  style="border: 1px solid #cbcbcb; border-bottom: 0"
                  tooltip-effect="dark"
                  @row-click="handleClickRow"
                  highlight-current-row
                  :cell-style="{ cursor: 'pointer' }"
                  :header-cell-style="{
                    background: '#f9f9f9',
                    color: '#333333',
                    fontWeight: '500',
                  }"
                >
                  <el-table-column label="邮箱/手机号" prop="targetId" show-overflow-tooltip></el-table-column>
                  <el-table-column label="名称" prop="userName" show-overflow-tooltip></el-table-column>
                  <el-table-column label="部门" prop="groupNames" show-overflow-tooltip></el-table-column>
                </el-table>
              </el-col>
              <!-- pagination -->
              <el-col :span="24" style="padding: 30px 0; position: relative" class="page-flex-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="filterModel.itemPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="filterModel.pageSize"
                  layout="sizes, prev, pager, next, total"
                  :total="filterModel.pageTotal"
                />
                <el-go
                  style="right: 0"
                  :page-size="filterModel.pageSize"
                  :total="filterModel.pageTotal"
                  @current-change="handleCurrentChange"
                ></el-go>
              </el-col>
            </section>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="visibleDialogSelectCopy = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="handleSelectCopyOk()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- footer (cancel and submit button) -->
    <div class="footer" style="text-align: right">
      <el-button @click="approvalCancel" size="mini">取消</el-button>
      <el-button @click="approvalOk" size="mini" type="danger" style="margin-right: 50px">确定</el-button>
    </div>
  </div>
</template>

<script>
import Flow from "../../../components/flow";
import Plus from "../../../components/flow/Plus";
import ElGo from "../../../components/go/Go";

import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { callbackLog } from "@/assets/js/utils/publicMethods";
import { dingtalkApi } from "../../../assets/js/http-serve/dingtalkApi";
// ⚠️ dingtalk-jsapi 只能在客户端（浏览器）中使用
let dd = null;
if (process.client) {
  dd = require('dingtalk-jsapi');
}
export default {
  name: "approval",
  components: { Flow, Plus, ElGo },
  data () {
    return {
      loading: null,
      copyToMembers: [],
      tableSetManager: [],
      memberGroups: [],
      filterModel: {
        targetId: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      },
      visibleDialogSelectCopy: false,
      // 【1466】
      // 查看使用范围
      viewRangeVisi: false,
      // 选择
      // 【1466】 end
      // approval model include apply and sign
      approvalModel: {
        approvalName: "",
        aprrovalID: "",
        approvalRange: "", // only apply approval
        selectUsers: [],
        approvalType: 1,
        approvalFlow: "",
        copyToName: "",
        useFileAuditFlag: 0,
        dingTalkUserIds: []
      },
      rules: {
        approvalName: [
          { required: true, message: "请输入审批名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        approvalType: [{ required: true, message: "请选择审批类型", trigger: "blur" },],
        dingTalkUserIds: [
          { required: true, message: "请选择使用范围", trigger: ["blur", 'change'] },
        ],
      },
      selectedApproval: [],

      // approval flow
      addOrUpdateApprovalor: true, // true add , false update
      flows: []
    };
  },
  watch: {},
  computed: {
    isEdit () {
      const { flowId } = this.$route.query;
      return flowId ? true : false
    },
    addOrUpdateApprovalorTitle () {
      if (this.addOrUpdateApprovalor) {
        return "添加审批人";
      } else {
        return "编辑审批人";
      }
    },
    flowType () {
      return this.$route.query.flowType === 0 ? 1 : 2;
    },
    flowId () {
      return this.$route.query.flowId ? parseInt(this.$route.query.flowId) : null;
    }
  },
  created () {
    this.$nextTick(() => {
      // console.log('this.$route.query', this.$route.query);
      const { flowId, flowName, flowType, status, nodes, webCCUsers } = this.$route.query;
      this.approvalModel.approvalName = flowName ? flowName : ''
      if (flowType) this.approvalModel.approvalType = parseInt(flowType)
      // console.log('webCCUsers', webCCUsers);
      if (webCCUsers) {
        webCCUsers.forEach(cUser => {
          this.copyToMembers.push({
            ...cUser,
            targetId: cUser.corpUserIdSec,
            partyName: cUser.corpUserName
          })

        })
      }

      if (nodes) {
        const _nodes = [...nodes];
        let _flows = [];
        _nodes.map(item => {
          item.userApproveUsers.forEach(user => {
            const _user = { name: user.name, emplId: user.userId };
            _flows.push(_user);
          });
        });
        this.flows = _flows;
      }
    });
  },
  methods: {
    /** 移除使用范围的某个人 */
    tagRemove (tag) {
      this.approvalModel.dingTalkUserIds.forEach((item, i) => {
        if (tag.emplId === item.emplId) this.approvalModel.dingTalkUserIds.splice(i, 1)
      })
    },
    handleClickCopyRemove (v) {
      if (v) {
        this.copyToMembers.splice(this.copyToMembers.indexOf(v), 1);
        this.formaterApprovalCopy();
      }
    },
    handleClickRow (row) {
      this.selectApprovalorTableRow = row;
    },
    // 重置
    approvalReset () {
      this.filterModel = {
        targetId: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      }
      this.handleClickSearchManager()
    },
    handleClickSearchManager () {
      this.queryTool();
    },
    // 分页事件
    handleSizeChange (val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.queryTool();
    },
    handleCurrentChange (val) {
      this.filterModel.itemPage = val;
      this.queryTool();
    },
    handleSelectCopyOk () {
      let v = {}, { corpUserIdSec, userName } = this.selectApprovalorTableRow;
      // fixed member
      v = JSON.parse(JSON.stringify(this.selectApprovalorTableRow));
      v.partyType = 0;
      v.targetId = corpUserIdSec;
      v.partyName = userName;

      if (v.partyName || v.targetId) {
        let exist = false;
        for (let index = 0; index < this.copyToMembers.length; index++) {
          const element = this.copyToMembers[index];
          if (
            element.partyType === v.partyType &&
            element.targetId === v.targetId
          ) {
            exist = true;
            break;
          }
        }
        if (exist) {
          this.$message.error("抄送人不能重复");
          return;
        }
        if (this.selectCopyUpdate) {
          // update
          this.copyToMembers.splice(
            this.copyToMembers.indexOf(this.selectCopyUpdate),
            1,
            v
          );
          this.formaterApprovalCopy();
        } else {
          // new add
          this.copyToMembers.push(v);
          this.formaterApprovalCopy();
        }
        this.visibleDialogSelectCopy = false;
        this.selectCopyUpdate = null;
      } else {
        this.$message.error("请选择抄送人");
      }
    },
    formaterApprovalCopy () {
      let v = [];
      this.copyToMembers.forEach(element => {
        v.push({
          partyType: element.partyType,
          targetId: element.targetId
        });
      });
      if (v.length) {
        this.approvalModel.copyToName = JSON.stringify(v);
      } else {
        this.approvalModel.copyToName = "";
      }
    },
    resetFilterModel () {
      this.filterModel.targetId = "";
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = 10;
      this.filterModel.pageTotal = 0;
      this.tableSetManager = [];
    },
    handleClickCopyUpdate (v) {
      this.addOrUpdateCopy = false;
      this.resetFilterModel();
      this.visibleDialogSelectCopy = true;
      this.queryTool();
      this.selectCopyUpdate = v;
    },
    handleClickCopyPlus () {
      this.addOrUpdateCopy = true;
      this.resetFilterModel();
      this.visibleDialogSelectCopy = true;
      this.queryTool();
    },
    queryTool () {
      this.selectApprovalorTableRow = {};
      ApiCorpMethods.OrganizationController.listCorpUsers(this.filterModel)
        .then(res => {
          if (res.code === "0") {
            this.tableSetManager = res.data;
            this.filterModel.pageTotal = res.total;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // 【1466】 start
    /** 选择 */
    initMemberForm () {
      // 鉴权 + 选人
      const corpId = sessionStorage.getItem("corpId"), _this = this;
      let users = [];
      if (_this.approvalModel.dingTalkUserIds) users = _this.approvalModel.dingTalkUserIds.map(user => {
        return user.emplId
      })
      // approvalModel.dingTalkUserIds
      dd.chooseStaffForPC({
        max: 150,
        users,
        corpId,
        multiple: true,
        success: res => {
          _this.$set(_this.approvalModel, 'dingTalkUserIds', [...res])
        },
      }).catch((err) => { console.log('catch_err', err); });
    },
    // 【1466】 end
    initApprovalInfo () {
      const { dingTalkCorpId: corpId,
        dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo"))
      let params = {
        corpId,
        dingTalkUserId,
        flowId: this.flowId
      }, _this = this;
      dingtalkApi.scopeuserList(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              let data = res.data;
              const dingUser = data.map(user => {
                return { name: user.dingTalkUserName, emplId: user.dingTalkUserId }
              })
              _this.$set(_this.approvalModel, 'dingTalkUserIds', dingUser)
            }
          } else {
            _this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // 删除某个审批人
    delUser (user) {
      this.flows.forEach((item, i) => {
        const idType = item.emplId === user.emplId;
        if (idType) {
          this.flows.splice(i, 1);
        }
      });
    },
    approvalCancel () {
      if (true) {
        this.$confirm("是否保存审批?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.approvalOk();
          })
          .catch(() => {
            this.$router.push(
              `/console/flow?flowType=${this.flowType === 1 ? 1 : 0}`
            );
          });
      } else {
        this.$router.push(
          `/console/flow?flowType=${this.flowType === 1 ? 1 : 0}`
        );
      }
    },
    approvalOk () {
      this.$refs["formApproval"].validate(valid => {
        if (valid) {
          this.approvalSave();
        }
        return false;
      });
    },

    approvalSave () {
      const _this = this;
      if (!_this.approvalModel.approvalType) return _this.$message.error('请选择审批类型')
      if (_this.flows.length === 0) return _this.$message.error("请添加审批人");
      _this.loadingStart()
      let nodes = [];
      const { approvalName, approvalType, dingTalkUserIds } = _this.approvalModel,
        dingtokenInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      const users = dingTalkUserIds && dingTalkUserIds.map(user => {
        return {
          dingTalkUserName: user.dingTalkUserName ? user.dingTalkUserName : user.name,
          dingTalkUserId: user.dingTalkUserId ? user.dingTalkUserId : user.emplId
        }
      })
      const workflowReq = {
        flowName: approvalName,
        flowType: approvalType,
        ccUsers: [],
        corpId: dingtokenInfo.dingTalkCorpId,
        dingTalkUserId: dingtokenInfo.dingTalkUserId,
        dingTalkUsers: users
      };
      const _webCCUsers = _this.copyToMembers.map(user => {
        return {
          corpUserIdApplySign: user.corpUserIdSec || user.corpUserIdApplySign,
          corpUserName: user.userName || user.partyName
        }
      })
      workflowReq.webCCUsers = _webCCUsers
      if (!_this.flowType && dingTalkUserIds.length === 0) {
        _this.loadingClose()
        return _this.$message.error('请选择使用范围')
      }
      if (_this.flowId) {
        workflowReq.flowId = _this.flowId;
      }
      // approvalModel.approvalType 1 顺序审 2 会审
      if (approvalType === 1) {
        // 顺序审
        _this.flows.forEach(user => {
          nodes.push({
            userApproveUsers: [{ name: user.name, userId: user.emplId }]
          });
        });
      }
      if (approvalType === 2) {
        // 会审
        const userList = [];
        _this.flows.forEach(user => {
          userList.push({
            name: user.name,
            userId: user.emplId
          });
        });
        nodes.push({ userApproveUsers: userList });
      }
      workflowReq.nodes = nodes;
      dingtalkApi.makeFlow(workflowReq).then(res => {
        if (!res.success) {
          _this.loadingClose()
          return _this.$message.error(res.description)
        };
        setTimeout(() => {
          callbackLog({module:6,desc:`${_this.flowId ? '编辑' : '新增'}${workflowReq.useScopeType == 1 ? '印章' :'合同'}审批流程：${approvalName}(ID：${workflowReq.flowId || res.data})`})
          _this.loadingClose()
          // this.$router.push({ path: "/console/dingComponents/dingFlow" });
          _this.$router.go(-1)
          _this.$message.success(_this.flowId ? `${res.description || '操作成功'}` : `${res.description}新增成功！成员数据写入中，请耐心等待几秒后刷新页面`)
          // this.$emit('update:addFlowPupVisi', false)
          _this.$emit('filterSearch')
        }, 5 * 1000);
      });
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 添加审批人
    handleClickFlowPlus () {
      // 鉴权 + 选人
      const corpId = sessionStorage.getItem("corpId"), _this = this;
      let users = [], assets = [];
      _this.flows.forEach(item => {
        item.emplId !== '-1' ? users.push(item.emplId) : assets.push(item);
      });
      dd.chooseStaffForPC({
        max: 20,
        users,
        corpId,
        multiple: true,
        success: res => {
          const newAddUsers = res.filter(user=>!users.includes(user.emplId));
          _this.flows = _this.flows.concat(newAddUsers);
        },
      }).catch((err) => { console.log('catch_err', err); });
    },
    addManager () {
      const have = this.flows.some(item => item.emplId === '-1')
      if (have) return this.$message.error('请勿重复添加审批人')
      this.flows.push({ name: '部门直属主管', emplId: '-1' })
    },
  },
  mounted () {
    if (this.$route.query.flowId) {
      this.initApprovalInfo();
    }
  },
};
</script>

<style scoped lang="less">
.custom-inline {
  .both::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    visibility: hidden;
    clear: both;
  }
}
.choose-tips {
  background-color: #fff5e6;
  border-color: #ffebcc;
  padding: 5px;
  margin-bottom: 10px;
}
.close-icon {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 5px;
  right: 10px;
}
.close_icon {
  cursor: pointer;
  background-image: url("/images/icon/icon_close.png");
  background-size: 100% 100%;
  &:hover {
    background-image: url("/images/icon/icon_colse_hover.png");
  }
}
.flow-sty {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  > div {
    display: flex;
    align-items: center;
  }
}
.men-item {
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  .name-warp {
    width: 66px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.item-close {
  display: inline-block;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>
<style scoped>
.approval {
  padding: 20px;
  position: relative;
  background: #ffffff;
}

.footer {
  border-top: 1px solid #cccccc;
  padding: 15px;
}

.custom-a {
  color: #5597ec;
  text-decoration: underline;
}

.custom-a:hover {
  color: red;
}

.content >>> .el-form-item {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// pages/console/dingComponents/Approval.vue